<template>
  <v-app id="listOccupancy1">
    <v-main>
      <v-container fluid>

      <v-row>


          <v-col cols="2" class="mx-2">
            <v-menu
              v-model="vanDatmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="vanDat" 
              label="From date"
              clearable
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="vanDat = $moment(hulpDate).format('DD-MM-YYYY'); vanDatmenu = false"></v-date-picker>
            </v-menu>  
          </v-col>  


          <v-col cols="2" class="mx-2">
            <v-menu
              v-model="tmDatmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="tmDat" 
              label="Until date"
              clearable
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="tmDat = $moment(hulpDate).format('DD-MM-YYYY'); tmDatmenu = false"></v-date-picker>
            </v-menu>  
          </v-col>  

      </v-row>  

      
      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="ovrz" :disabled="submitted">Create excel</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
     <showProgress ref="showProgress"></showProgress>
     <navBar title="Ares - Main menu" :home="true" :accolist="true" type="main"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import showProgress from "@/components/showProgress.vue";
 export default {
  components: {
    navBar,
    showProgress
  },
  data() {
    return {
      vanDat: '',
      vanDatmenu: false,
      tmDat: '',
      tmDatmenu: false,
      items: {},
      submitted: false,
      hulpDate: ''
    }
  },
  methods: {
     ovrz() {
      this.submitted = true;
      this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/huis/ovrz/excelExportListOccupancy1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportListOccupancy1"
          },
          excelExportListOccupancy1: {
            vanDat: this.vanDat,
            tmDat: this.tmDat
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.excelExportListOccupancy1;
            this.$refs.showProgress.close();
            window.open(this.items.filename,'_blank');
            this.submitted = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
